import { initComic, setComic } from '@modules/comic';
import { useDispatch } from '@stores';
import { IStoreComic } from '@types';
import { useCallback } from 'react';

const useComicActions = () => {
  const dispatch = useDispatch();

  const onInitComic = useCallback(() => {
    dispatch(initComic());
  }, [dispatch]);

  const onSetComic = useCallback(
    (payload: Partial<IStoreComic>) => {
      dispatch(setComic(payload));
    },
    [dispatch]
  );

  return { onInitComic, onSetComic };
};

export default useComicActions;
